// IdentityPanel — the bar's own state-machine slot (narcis wall plan step 4). Real narcis token
// names with fallbacks, matching `header.module.scss`'s own idiom for this house — the shared
// `@core/wall/ui` chrome around this chip (`.idChip`, the bar itself) still reads Toile's `--tl-*`
// names, a pre-existing gap this file does not attempt to close.

.chip {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
    // Fills the bar's identity slot (`.idChip`, core, which takes the whole room up to the pencil),
    // so the training track runs from the thumb to the verb.
    flex: 1;
}

.thumb {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: var(--radius-sm, 6px);
    overflow: hidden;
    background: var(--surface-hover, #1f1f23);
}

// The empty frame (board `.th.empty`): a dashed hairline, no fill — the slot the model will fill.
.thumbEmpty {
    background: none;
    border: 1px dashed var(--text-dim, #63635e);
}

.thumbImg {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.name {
    font-family: var(--font-display, 'Fraunces', Georgia, serif);
    font-style: italic;
    font-weight: 500;
    font-size: 15px;
    color: var(--text, #faf9f7);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 140px;
}

.nameDim {
    color: var(--text-dim, #63635e);
}

.prog {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

// Board `.prog span`: mono, small caps, dim — the time itself in yolk.
.line {
    font-family: var(--font-mono, 'JetBrains Mono', monospace);
    font-size: 10px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--text-dim, #63635e);
    white-space: nowrap;
}

.eta {
    color: var(--yolk, #e8c24a);
    font-weight: 400;
}

// Board `.prog i` — the track across the slot; `.prog i b` the fill.
.track {
    display: block;
    width: 100%;
    height: 2px;
    border-radius: 999px;
    background: var(--surface-hover, #1f1f23);
    overflow: hidden;
}

.fill {
    display: block;
    height: 100%;
    border-radius: 999px;
    background: var(--yolk, #e8c24a);
    transition: width 600ms ease;
}

// No percentage yet — an ambient sweep on the same track.
.shimmer {
    display: block;
    width: 40%;
    height: 100%;
    border-radius: 999px;
    background: var(--yolk, #e8c24a);
    animation: identityHairline 1.6s ease-in-out infinite;
}

@keyframes identityHairline {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(250%);
    }
}
